import React from "react";
import { Modal } from "antd";
import "../../components/common/H5PromptModal.css";
import "./DesktopOnlyTipModal.css";

const DESKTOP_SITE = "v.longfans.com";

function DesktopOnlyTipContent() {
  return (
    <>
      <div className="lf-h5-prompt-modal__icon" aria-hidden>
        💻
      </div>
      <p className="lf-h5-prompt-modal__title">该功能暂不支持手机浏览</p>
      <p className="lf-h5-prompt-modal__desc">
        请前往电脑端打开
        <span className="lf-h5-desktop-only-tip__site">{DESKTOP_SITE}</span>
        后使用
      </p>
    </>
  );
}

function DesktopOnlyTipActions(props: { onClose: () => void }) {
  return (
    <div className="lf-h5-prompt-modal__actions lf-h5-prompt-modal__actions--single">
      <button
        type="button"
        className="lf-h5-prompt-modal__btn lf-h5-prompt-modal__btn--primary lf-h5-prompt-modal__btn--block"
        onClick={props.onClose}
      >
        我知道了
      </button>
    </div>
  );
}

function openDesktopOnlyModal(content: React.ReactNode): void {
  const modal = Modal.info({
    className: "lf-h5-prompt-modal",
    icon: null,
    centered: true,
    width: 320,
    closable: true,
    maskClosable: true,
    footer: null,
    content: (
      <>
        <div className="lf-h5-prompt-modal__body">{content}</div>
        <DesktopOnlyTipActions onClose={() => modal.destroy()} />
      </>
    ),
  });
}

/** 统一的「请前往电脑端」提示弹框（圆角 12px） */
export function showDesktopOnlyTipModal(): void {
  openDesktopOnlyModal(<DesktopOnlyTipContent />);
}

/** 概念库仅支持电脑端访问时的提示 */
export function showConceptLibraryDesktopTipModal(): void {
  openDesktopOnlyModal(
    <>
      <p className="lf-h5-prompt-modal__title">概念库暂不支持手机浏览</p>
      <p className="lf-h5-prompt-modal__desc">
        请前往电脑端查看和使用概念库，概念库目前仅支持电脑端访问。
      </p>
    </>
  );
}
